import httpService from '@/api/httpService'

const MinskApi = (() => {
  const apiPostfix = 'documents'

  return {
    apiPostfix: apiPostfix,

    async getDocuments () {
      const response = await httpService.get(`delivery/${apiPostfix}/minsk`)
      return response.data
    }
  }
})()

export default MinskApi
